import { BaseBus } from "./BaseBus";

export class CustomerDispatchStatisticsDetail extends BaseBus{
    constructor(data: CustomerDispatchStatisticsDetail) {
        super(data);
    }
    initialize(data: CustomerDispatchStatisticsDetail) {
        super.initialize(data);

    }

    dispatchId: string;
    callbackId: string;
    dispatchNumber: string;
    creationDate?: Date;
    firstAssignment?: Date;
    lastForReviewDate?: Date;
    firstForReviewDate?: Date;
    firstWorkTimeDate?: Date;
    timeFrnoCallbacks?: number;
    timeFrWithCallbacks?: number;
    timeFrCallbacksOnly?: number;
    firstAssignmentTime?: number;
    firstWorkTime?: number;
    customerName: string;
    locationName: string;
    callbackDispatchNumber: string;
    dispatchStatusName: string;
    isConstruction: boolean;
    callbackDispatchId: string;
    isCallbackConstruction: boolean;
}
